import withAttachmentsAndMediaFiles from '../withAttachmentsAndMediaFiles';
import BulkPage from './BulkItemListPage';

export const BulkItemListPage = withAttachmentsAndMediaFiles(BulkPage);
